import templateStr from 'text!./bop-building-directive.html';
import PropertyCodeUtil from 'edge/quoteandbind/common/util/PropertyCodeUtil';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            building: '=',
            isAccordionOpen: '=',
            showActions: '=',
            remove: '&',
            edit: '&'
        },
        controller: ['$scope', 'InsuranceSuiteMetadata', 'ModalService', '$filter', function ($scope, insuranceSuiteMetadata, ModalService, $filter) {
            var typelist = insuranceSuiteMetadata.get('pc').types.getTypelist('Sprinklered');
            $scope.sprinklered = $scope.building.percentageSprinklered ? typelist.getCode($scope.building.percentageSprinklered).name : null;

            $scope.handleRemove = function () {
                ModalService.showWarning('quoteandbind.bop.views.bop-buildings-locations.RemoveBuildingTitle', 'quoteandbind.bop.views.bop-buildings-locations.RemoveBuildingMessage', undefined, $filter('translate')('quoteandbind.bop.views.bop-buildings-locations.RemoveActionLabel')).result.then(function () {
                    return $scope.remove()();
                });
            };

            $scope.handleEdit = function () {
                $scope.edit()();
            };

            $scope.baseCovExist = $scope.building.baseCoverages.filter(function (cov) {
                return cov.selected;
            }).length <= 0;
            $scope.additionalCovExist = $scope.building.additionalCoverages.filter(function (cov) {
                return cov.selected;
            }).length <= 0;

            $scope.formatClassCode = PropertyCodeUtil.toString;
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-bop-components-angular/locationsAndBuildings/directives/bop-building-directive/BOPBuildingDirective.js
// module id = 1806
// module chunks = 0